export const extractPhoneNumber = (phoneNumber:string) => {
  if(phoneNumber[0] === '+') {
    return (phoneNumber.split(/^(\+47|\+46)/i).slice(-2));
  }
  else {
    return ['+47',phoneNumber];
  }
}
